<template>
    <Toast position="bottom-right"/> 
    <div class='resultados tw-w-full tw-flex tw-justify-center tw-h-full  tw-items-center tw-p-2'>
        <Card style='background:none;box-shadow:none;' class='animate tw-w-full tw-h-full! p-shadow-5'>
            <template #title>
                <div class='tw-bg-gray-50 tw-rounded tw-py-4 tw-shadow-lg'>
                    <h3>Resultados</h3>
                    <span class='tw-text-sm'>Es IMPORTANTE que la interpretación de estos Resultados la realices junto a tu médico.</span>
                </div>
            </template>
            <template #content>
                <div class="tw-w-full tw-flex tw-items-center tw-justify-center">
                    <SelectButton @change="handleTipoChange" size="small" :options="tipos" v-model="tipoSeleccionado" aria-labelledby="basic" />
                </div>
                <div ref='contenedorResultados' v-if='evolucionesList?.length > 0' style='max-height:calc(100vh - 34vh);' class='tw-w-full tw-grid xl:tw-grid-cols-2 tw-gap-2 tw-mx-auto tw-mt-2 tw-bg-gray-100 tw-overflow-auto tw-p-2 tw-rounded'>
                    <resultados-card  v-for="(item, index) in evolucionesList" :key="item" @compartir='handleCompartirClick(index)' @ver='handleVerClick(index)' @visualizar="handleVisualizar(index)" :datos='item'></resultados-card>  
                </div>
                <div v-else style='max-height:calc(100vh - 35vh)' class='tw-w-full tw-mt-2 tw-bg-gray-50 tw-overflow-auto tw-p-2 tw-space-y-2 tw-rounded'>
                    <span>No se encontraron resultados.</span>
                </div>
            </template>
        </Card>

    </div>
    <!--  -->
    <Dialog v-model:visible="resultadoFormActive" class="popup-visorEstudios" :style="{'width':'100%','height':'100%'}">
        <template #header> <div class='tw-w-full'></div> </template>
        <div v-if='resultadoFormActive' class='tw-w-full tw-h-full'>
            <iframe :src="evolucionSeleccionada?.pac?.estudio?.visor" frameborder="0" width="100%" height="100%"></iframe>
        </div>
    </Dialog>

</template>

<script lang='ts'>
import { defineComponent, ref, onBeforeMount, computed ,watchEffect} from 'vue'
import { useToast } from "primevue/usetoast";

import ResultadosCard from '@/components/ResultadosCard.vue'
import axios from '@/plugins/axios';
import moment from 'moment';

import { useStore } from 'vuex';
import { jsPDF } from 'jspdf';

import Pac from '@/modules/Pac'
import LabFHIR from '@/modules/LabFHIR'


import { imprimirHC } from '@/hooks/useImpresion';

const PUBLIC_ARCHIVE_TYPES = [
    "LAB", "RX", "TC", "EC", "QX", "AP", "PAP", "RMN",'EDC',
    'ESC','EVC','EDV','EDA','HOL','MAP','ERC','TCM', 'CEN',
    'VNG','EEG','POLI','EMG','COGNI','URO','FONO','UNR','INF'
];
type PublicArchiveTypes = "LAB" | "RX" | "TC" | "EC" | "QX" | "AP" | "PAP" | "RMN" | 'EDC'
                        | 'ESC'| 'EVC'| 'EDV'| 'EDA'| 'HOL'| 'MAP'| 'ERC'| 'TCM' | 'CEN' 
                        | 'VNG' | 'EEG' | 'POLI' | 'EMG' | 'COGNI' | 'URO' | 'FONO' | 'UNR' | 'INF';

export default defineComponent({
    components:{
        ResultadosCard
    },
    setup: () => {
        const toast = useToast();
        const store = useStore();
        const contenedorResultados = ref<HTMLDivElement>();
        const resultadoFormActive = ref(false);
        
        const medicos = ref([{nombre:'Patricio Esponja'}]);
        const medicoSeleccionado = ref(null);
        const especialidades = ref([{nombre:'Pediatria'}]);
        const especialidadSeleccionada = ref(null);
        const fecha = ref([new Date()]);

        const tipos = ref(['Todo', 'Estudios', 'Imagenes']);
        const tipoSeleccionado = ref('Todo');

        
        const evolucionesList = ref();
        const evolucionSeleccionada = ref();
        const pagina = ref(1);
        const itemsPorPagina = ref(10);
        const cantidadResultados = ref();

        const archivesNames : Record<PublicArchiveTypes,string> = {
            LAB:'Laboratorio',
            RX:'Radiologia',
            TC:'Tomografia',
            EC:'Ecografia',
            QX:'Parte Quirurgico',
            AP:'Anatomia Patologica',
            PAP:'Papanicolau',
            RMN:'Resonancia Magnetica Nuclear',
            EDC:'Eco Doppler Cardiaco',
            ESC:'Eco Stress Cardiaco',
            EVC:'Eco Doppler de vasos de cuello',
            EDV:'Eco Doppler venoso',
            EDA:'Eco Doppler arterial',
            HOL:'Holter',
            MAP:'Presurometria (MAPA)',
            ERC:'Ergonometria computarizada',
            TCM:'Test de caminata de 6 minutos',
            CEN:'Centellograma',
            VNG:'Videonistagmografía',
            EEG:'Electroencefalograma',
            POLI:'Polisomnografía',
            EMG:'Electromiografía',
            COGNI:'Estudios cognitivos',
            URO:'Estudios urología',
            FONO:'Estudios fonoaudiología',
            UNR:'Estudios unidad de neuro rehabilitación',
            INF:'Informe de imagenes',
        }
        
        
        const handleTipoChange = () => {
            pagina.value = 1;
            obtenerRegistros(true)
        }

        const updateItem = async (index:number) => {
            const itemUpdated = evolucionesList.value[index];
            if(!itemUpdated.downloaded){
                const nombre = itemUpdated.datos?.nombre
                const result = await axios.get(`/historia-clinica-get-registros/${itemUpdated._id}`)
                itemUpdated.downloaded = true;
                itemUpdated.datos = result.data.datos;
                itemUpdated.medico = result.data.medico;
                itemUpdated.datos.especialidad = result.data.especialidad;
                itemUpdated.datos.nombre = nombre;
            }
            return itemUpdated;
        }

        const handleCompartirClick = async (index: number) => {
            try {
                let itemUpdated = evolucionesList.value[index];
                if(!itemUpdated.downloaded){
                    itemUpdated = await updateItem(index);
                }
                
                const blob = await getFile(itemUpdated);
                itemUpdated.file = blob;

                evolucionesList.value[index] = itemUpdated;

                if(!blob){
                    toast.add({severity:'warn',summary:'Atencion',detail:'El informe aún no está disponible.',life:1500})
                    return;
                }

                const file = new File([blob],'Resultado.pdf', { type: 'application/pdf' });

                if(navigator.canShare && navigator.canShare({ files: [file] })){
                    
                    await navigator.share({
                        files: [file],
                        title: 'Resultado de Laboratorio',
                        text: 'Resultado de Laboratorio'
                    })
                    toast.add({severity:'success',summary:'Exito',detail:'El archivo se ha compartido correctamente.',life:1500})
                    return;
                }
                toast.add({severity:'warn',summary:'Atencion',detail:'No se puede compartir el archivo.',life:1500})
                
            } catch (error) {
                console.log(error);
                toast.add({severity:'warn',summary:'Atencion',detail:'No se puede compartir el archivo.',life:1500})
            }
        }

        const getFile = async (item:any) => {
            if(item.file){
                return item.file
            }

            if(item.tipo === 'LABO'){
                return await getImpresionLabo(item, {blob:true});
            }

            if(item.datos?.file?.location){
                return await downloadArchive(item.datos.file, {blob:true});
            }

            if(item.tipo === 'PAC'){
                const pac = await Pac.getInformeHC(item);
                return await downloadPacArchive(pac, {blob:true});
            }

            if(item.tipo === "LABFHIR"){
                const labFHIR = await LabFHIR.getInformeHC(item)
                return await downloadLabFHIRArchive(labFHIR, {blob:true});
            }

            return await getPrintedFile(item, {blob:true});	
        }

        const getPrintedFile = async (item:any, {blob = false} = {}) => {
            const pdfjs =  new jsPDF({
                format: 'a4',
                unit:'pt',
                hotfixes:["px_scaling"]
            });

            if(!item.medico?.logofirma){
                if(blob){
                    return null;
                }
                toast.add({severity:'warn',summary:'Atencion',detail:'Resultado sin firma.',life:1500})
                return;
            }

            await imprimirHC(item,pdfjs, store.state.configuracionPortal.cliente);
            const blobPdf = await pdfjs.output('blob');
            return blobPdf;
        }


        const handleVerClick = async (index:number) =>{
            try {
                

                let itemUpdated = evolucionesList.value[index];
                if(!itemUpdated?.downloaded){
                    itemUpdated = await updateItem(index);
                }

                const blob = await getFile(itemUpdated);
                itemUpdated.file = blob;
                evolucionesList.value[index] = itemUpdated;

                if(!blob){
                    toast.add({severity:'warn',summary:'Atencion',detail:'El informe aún no está disponible.',life:1500})
                    return;
                }

                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = itemUpdated.datos?.nombre ? 
                    `${itemUpdated.datos?.nombre} - ${moment(itemUpdated.datos.fecha).format('DD_MM_YYYY')}.pdf`
                    : `Resultado.pdf`;
                a.click();
                URL.revokeObjectURL(a.href);


            } catch (error) {
                console.log(error);
            }
        }

        const getImpresionLabo = async (item:any, {blob = false} = {}) => {
            try {
               const { data } = await axios.post('/lab-estudio/imprimir', {filtros:{idestudio:item.id}})
               
               
                await consultPrintStatus(data.uuid);

                const blobPdf = await getPdfEstudio(data.uuid, {blob});

                if(blob) return blobPdf;

            } catch (error) {
                console.log(error);
            }
        }

        const getPdfEstudio = async (uuid:string,{blob = false} = {}) => {
            const pdf = await axios.get('/lab-estudio/get-impresion',{params:{uuid},responseType:'blob'});
            let reader = new FileReader();
            if(blob){
                return pdf.data;
            }
            reader.readAsDataURL(pdf.data);
            reader.onloadend = () => {
                let base64data = reader.result;
                let link = document.createElement('a');
                link.href = base64data as string;
                link.download = `Estudio de Laboratorio` + '.pdf';
                link.click();
            }
        }

        const consultPrintStatus = async (uuid:string) => {
            let timer:any;
            await new Promise((resolve,reject) => {
                timer = setInterval(() => {
                    axios.get('/lab-estudio/get-impresion-status',{params:{uuid}})
                    .then(({data}) => {
                        if(data.status === 'finished'){
                            clearInterval(timer);
                            resolve(data);
                        }
                        if(data.status === 'error'){
                            clearInterval(timer);
                            reject(data);
                        }
                    }).catch((error) => {
                        clearInterval(timer);
                        reject(error);
                    })
                }, 1000);
            })

            timer && clearInterval(timer);
        }

        const handleVisualizar = async (index:number) => {
            let itemUpdated = evolucionesList.value[index];
            if(!itemUpdated.downloaded){
                itemUpdated = await updateItem(index);
            }

            if(!itemUpdated.pac) {
                const pac = await Pac.getInformeHC(itemUpdated);
                itemUpdated.pac = pac;
            }

            
            evolucionesList.value[index] = itemUpdated;
            evolucionSeleccionada.value = itemUpdated;
            resultadoFormActive.value = true;
        }

        const downloadArchive = async (file:any, {blob = false} = {}) => {
            if(blob){
                const blob = (await fetch(file.location)).blob();
                return blob;
            }
            let link = document.createElement('a');
            link.href = file.location;
            link.download = file.name;
            link.click();
        }

        const downloadLabFHIRArchive = async (estudio:any, {blob = false} = {}) => {
            if (!estudio.informe || !estudio.informe.data || estudio.informe.data.trim() === '' || estudio.informe.data === 'QQ==') {
                if(blob){
                    return null;
                }
                toast.add({severity:'warn',summary:'Atencion',detail:'El informe aún no está disponible.',life:1500})
                return;
            }
            if (estudio.informe.contentType !== 'application/pdf') {
                if(blob){
                    return null;
                }
                toast.add({severity:'warn',summary:'Atencion',detail:'El informe aún no está disponible',life:1500})
                return;
            }
            let base64data = estudio.informe.data;
            if (!base64data.startsWith('data:')) {
                base64data = `data:${estudio.informe.contentType};base64,${base64data}`;
            }

            if(blob){
                const blob = (await fetch(base64data)).blob();
                return blob;
            }

            let link = document.createElement('a');
            link.href = base64data;
            link.download = `Estudio de Laboratorio` + '.pdf';
            link.click();
        }


        const downloadPacArchive = async (estudio:any,{blob = false} = {}) => {
            if(!estudio.estudio?.informeurl){
                return null;
            }
            const { data } = await axios.get('get-url?url=' + estudio.estudio?.informeurl, { responseType: 'blob' })
            if(data.size < 1000) {
                if(blob){
                    return null;
                }

                toast.add({severity:'warn',summary:'Atencion',detail:'Estudio no disponible.',life:1500})
            } else {
                let reader = new FileReader();
                if(blob){
                    return data;
                }
                reader.readAsDataURL(data);
                reader.onloadend = () => {
                    let base64data = reader.result;
                    let link = document.createElement('a');
                    link.href = base64data as string;
                    link.download = `Diagnostico Por Imagen` + '.pdf';
                    link.click();
                }
            }
        }

        const obtenerRegistros = async (isNew = false) => {
            try {
                
                const filtrosTipo : Record<string,any> = {
                    Todo: {$or:[
                        {tipo:'PAC'},
                        {tipo:'LABFHIR'},
                        {
                            $and:[
                                {$or:[
                                    {tipo:'HC'},
                                    ...PUBLIC_ARCHIVE_TYPES.map((tipo:string) => ({tipo}))
                                ]},
                                {'datos.isPublicable':true},
                                {'datos.datosPaciente.tipoCobertura':{$ne:'ART'}}
                            ]
                        }
                    ]},
                    Estudios: {
                        $or:[
                            {tipo:'LABFHIR'},
                            {$and:[
                                {$or:[{tipo:'HC'}, ...PUBLIC_ARCHIVE_TYPES.map((tipo:string) => ({tipo}))]},
                                {'datos.isPublicable':true}
                            ]}
                        ]
                        
                    },
                    Imagenes: {tipo:'PAC'}
                }

                const query = encodeURIComponent(JSON.stringify({...(filtrosTipo[tipoSeleccionado.value] || {})}));
                
                const { data } = await axios.get(`/historia-clinica-get-registros/${store.state.pacienteLogueado.id}/${pagina.value}/${itemsPorPagina.value}?query=${query}`);

                for(let dato of data.registros){
                    if(PUBLIC_ARCHIVE_TYPES.includes(dato.tipo)){
                        dato.datos.nombre = archivesNames[dato.tipo as PublicArchiveTypes];
                    }
                    if(dato.tipo === 'PAC'){
                        dato.datos.nombre = 'Diagnostico Por Imagen';
                    }
                }
                
                
                evolucionesList.value = evolucionesList.value && !isNew ? [...evolucionesList.value, ...data.registros] : data.registros;
                cantidadResultados.value = data.count;
                especialidades.value = data.especialidad;
                medicos.value = data.medicos;

                evolucionesList.value.forEach(async(item:any, index:number) => {
                    try {
                        if(!item.file && ( item.tipo === 'PAC' || item.tipo === 'LABFHIR')){
                        const result = await axios.get(`/historia-clinica-get-registros/${item._id}`)
                            if(item.tipo === 'PAC') {
                                const { data: estudio} = await axios.post('/turnos/get-estudio', { id: result.data.datos.idturno})
                                result.data.datos.prestaciones = estudio.prestaciones
                            }
                            const file = await getFile(result.data);
                            const nombre = item.datos?.nombre
                            const updatedItem = {
                                ...item,
                                ...result.data,
                                downloaded:true,
                                file:file,
                                
                            }
                            updatedItem.datos.nombre = nombre;
                            updatedItem.datos.practica = updatedItem.datos.prestaciones?.[0]?.descripcion?.toLowerCase() || null;
                            evolucionesList.value[index] = updatedItem;

                        }
                    } catch (error) {
                        console.log(error);
                    }
                })

                tipoSeleccionado.value !== 'Imagenes' && await obtenerEstudiosLabo();
                
            } catch (error) {
                console.log(error);
            }
        }

        const obtenerEstudiosLabo = async () => {
            try {
                const { data } = await axios.get('/lab-estudio/get-all', {
                    params:{
                        page:pagina.value,
                        pageSize:itemsPorPagina.value,
                        filters:{
                            idpaciente:store.state.pacienteLogueado.id,
                            validacion:{ne:null},
                            idturno:{ne:null},
                        },
                        includes:JSON.stringify([{
                            model:'labResultado',
                            attributes:['id'],
                            include:[{
                                model:'labDeterminacion',
                                as:'analito',
                                attributes:['id'],
                                include:[{
                                    required:true,
                                    model:'prestacion',
                                    as: 'prestacionDeterminacion',
                                    attributes:['entregaenpersona']
                                }]
                            }]
                        }]),
                        order:JSON.stringify([['fecha','DESC']])
                    }
                })

                evolucionesList.value = [...evolucionesList.value, ...data
                .filter((item:any) => !item.labResultados.some((resultado:any) => resultado?.analito?.prestacionDeterminacion?.entregaenpersona))
                .map((item:any) => ({
                    ...item, 
                    tipo:'LABO',
                    medico:item.medicovalidador,
                    datos:{...item, nombre:'Laboratorio'}}))
                ]

                evolucionesList.value.sort((a:any,b:any) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime());
            } catch (error) {
                console.log(error);
            }
        }

        const cantidadPaginas = computed(() => {
            return Math.ceil(cantidadResultados.value / itemsPorPagina.value);
        });

        watchEffect(() => {
            
            if(contenedorResultados.value){
                contenedorResultados.value.removeEventListener('scroll', eventoDeScroll);
                contenedorResultados.value.addEventListener('scroll', eventoDeScroll);
            }
        })
        
        onBeforeMount(() => {
            obtenerRegistros();
        })


        


        const eventoDeScroll = (e:any) => {
            const { target:{scrollTop, offsetHeight, scrollHeight} } = e;
            
            if(scrollTop + offsetHeight >= scrollHeight){
               
                pagina.value += 1;
                if(cantidadPaginas.value >= pagina.value){
                    
                    obtenerRegistros();
                }
            }
        }

        
        
        
        
        return {
            contenedorResultados,
            resultadoFormActive,
            medicos,
            medicoSeleccionado,
            especialidades,
            especialidadSeleccionada,
            fecha,
            evolucionesList,
            evolucionSeleccionada,
            tipos,
            tipoSeleccionado,
            handleVerClick,
            handleTipoChange,
            handleVisualizar,
            handleCompartirClick,
        }
    }

})
</script>

<style>
.popup-visorEstudios.p-dialog .p-dialog-content {
    height: 100%;
}
.resultados .animate {
    animation: entrada-resultados .2s ease forwards;
}
@keyframes entrada-resultados {
    0%{
        opacity: 0;
        
    }100%{
        opacity: 1;
        
    }
}
</style>